<template>
	<!-- 工人开机率工报表 -->
	<div class="rzy-page">
		<el-date-picker v-model="selectMonth" type="month" placeholder="选择月" @change="changeMonth" />
		<el-button type="success" @click="initExcel('workerRateTable')">导出Excel</el-button>
		<el-button type="primary" @click="initPrint('workerRateTable')">打印</el-button>
		<el-button type="primary" @click="toBatchPrint">批量打印</el-button>

		<el-table :data="workerRateList" :header-cell-style="{'text-align':'center'}" id="workerRateTable"
			:cell-style="{'text-align':'center','padding':'0px'}" border stripe max-height="600">
			<el-table-column label="员工">
				<template slot-scope="data">
					<el-link type="primary" @click="goToMonthDetails(data.row)">{{data.row.username}}</el-link>
				</template>
			</el-table-column>
			<el-table-column sortable label="类型" prop="roleName" />
			<el-table-column sortable label="班次" prop="shift" />

			<el-table-column :label="`${index+1}号`" v-for="(item,index) in lastDate" :key="item" width="80">
				<template slot-scope="data">
					{{data.row.dailyData[index].runningRate}}
				</template>
			</el-table-column>


		</el-table>
	</div>
</template>

<script>
	import api from '@/api/factory/statistics/worker'
	export default {
		name: 'workerRateList',
		data() {
			return {
				workerRateList: [],
				selectMonth: '', //选择月份
				lastDate: 0 //hongmj: 列表上最后1天。
			}
		},
		methods: {
			// 获取当前月所有挡车工的打卡数据
			getNowList() {
				const now = new Date()
				this.selectMonth = now
				this.getDangCheList(this.utils.getFirstTimeByMonth(now.getTime()), this.utils.getLastTimeByMonth(now
					.getTime()))
			},
			// 获取开始到结束时间的挡车工打卡数据
			getDangCheList(startTime, endTime) {
				const role = this.$enum.roleObj.dangche.value
				api.getList({
					role,
					startTime,
					endTime
				}).then(res => {
					if (this.utils.isNowMonth(startTime)) { //hongmj: 当天，列表最后1天 直接取今天。
						this.lastDate = new Date().getDate()
					} else { //hongmj:取当月最后1天。
						this.lastDate = new Date(endTime).getDate()
					}
					this.workerRateList = this.formatWorkerRateInfo(res.data)
				})
			},
			// 格式化打卡数据
			formatWorkerRateInfo(response) {
				// 按工人ID对返回数据分组
				var groupByWorkerId = this._.groupBy(response, (item) => {
					return item.workerId
				})
				var formatArr = [] //hongmj: 这个是返回值


				for (var workerId in groupByWorkerId) {
					var workerInfo = groupByWorkerId[workerId]
					var dailyData = []
					const monthDay = this._.range(0, this.lastDate, 0) // 1天工时统计
					for (const d in monthDay) {
						dailyData[d] = {
							dateDisplay: (Number(d) + 1).toString() + '号', //hongmj: 未使用，先预留.
							runningRate: '0%' //hongmj: 初期值.
						}
					}

					// 先把打卡数据  按日期 分组
					var groupByDaily = this._.groupBy(workerInfo, (info) => {
						return new Date(info.startTime).getDate()
					})
					for (var date in groupByDaily) {
						var oneDay = groupByDaily[date] // 取出1天的数据
						// console.log('oneday', oneDay)
						var workingHour = this.computeWorkingHour(oneDay) // 计算1天的总工时
						var m_validTime = this.computeValidTime(oneDay) // 计算1天的有效工时

						dailyData[date - 1].runningRate = (m_validTime / workingHour * 100).toFixed(2) + '%'
					}


					//hongmj: 这里把视图 和 数据 绑定。
					const formatObj = {
						workerId: workerInfo[0].workerId, //工号
						username: workerInfo[0].username, //用户名(员工)
						role: workerInfo[0].role, //角色
						roleName: this.$enum.roleObj.dangche.name, // 类型

						// hcy: 当日打卡时候，工人配置得是什么班次，会学到打卡的shift中，之后可能班次回修改，currentShift即反映个人当前的配置的班次.
						// 前端用shift，如果为空则用currentShift.
						shift: workerInfo[0].shift? workerInfo[0].shift: workerInfo[0].currentShift, //班次

						dailyData: dailyData //hongmj: 每天的数据?
					}
					formatArr.push(formatObj)

				}
				return formatArr
			},


			// 挡车工工时计算逻辑,一天中可能有多次上班 早班，夜班，故将工时计算逻辑抽出。
			computeWorkingHour(oneDay) {
				var sumTime = 0
				oneDay.forEach(item => {
					var tempResult = this.utils.milliToHour(item.endTime - item.startTime)
					// console.log('tempResult=', tempResult)
					sumTime += Number(tempResult)
				})
				// console.log('sumTime=', sumTime)
				return sumTime.toFixed(2)
			},

			//计算1天中的有效工时
			computeValidTime(oneDay) {
				var sumTime = 0
				oneDay.forEach(item => {
					sumTime += item.validTime //validTime是秒
				})
				// console.log('sumTime=', sumTime)
				return (sumTime / 3600).toFixed(2)
			},
			//-------------------------------------------------------------------
			// 选择月份
			changeMonth(val) {
				const selectTime = val.getTime()
				this.getDangCheList(this.utils.getFirstTimeByMonth(selectTime), this.utils.getLastTimeByMonth(
					selectTime))
			},
			// 导出excel初始化
			initExcel(id) {
				const select = new Date(this.selectMonth)
				const year = select.getFullYear()
				const month = select.getMonth() + 1
				this.utils.exportExcel(id, `${year}年${month}月挡车工报表`)
			},
			// 去月详情界面
			goToMonthDetails(row) {
				const id = row.workerId
				this.$router.push({
					path: `/statistics/workerMonthDetails/${this.$enum.roleObj.dangche.value}/${id}/${this.selectMonth.getTime()}`
				})
			},
			// 在打印当前报表前，拼接title
			initPrint(id) {
				var selectMonth = new Date(this.selectMonth)
				const year = selectMonth.getFullYear()
				const month = selectMonth.getMonth() + 1
				this.utils.printTable(id, `${year}年${month}月&nbsp;挡车工考勤统计表`)
			},
			// 跳转至批量打印界面
			toBatchPrint() {
				const routeData = this.$router.resolve({
					path: `/statistics/workerCountBatchPrint/${this.$enum.roleObj.dangche.value}/${this.selectMonth.getTime()}`
				})
				window.open(routeData.href, '_blank')
			}
		},
		created() {
			this.getNowList()
		},
		mounted() {
			console.log(this.selectMonth)
		}
	}
</script>

<style lang="scss"></style>